import { useState } from "react";
import { BASE_URL } from "../constants";
import { Modal, Textarea, Badge, Btn } from "./UI";


export default function ApplicantDetailModal({ app, token, jobId, onClose, onSuccess }) {
  const [loading, setLoading] = useState(false);
  const [note,    setNote]    = useState(app.agentNote || "");

  const action = async (act) => {
    setLoading(true);
    try {
      const res  = await fetch(`${BASE_URL}/agent/job/application-action/${app._id}`, {
        method:  "PATCH",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
        body:    JSON.stringify({ action: act, note }),
      });
      const data = await res.json();
      if (data.success) onSuccess(`Applicant marked as ${act}`, "success", act);
      else onSuccess(data.message || "Action failed.", "error");
    } catch {
      onSuccess("Network error.", "error");
    }
    setLoading(false);
  };

  const snap = app.applicantSnapshot;

  return (
    <Modal title="Applicant Details" onClose={onClose}>
      {/* Info grid */}
      <div style={{ background: "#f8fafc", borderRadius: 14, padding: 18, marginBottom: 20 }}>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14 }}>
          {[
            ["Phone",        snap.phone       || "—"],
            ["Experience",   snap.experience  || "—"],
            ["Current Role", snap.currentRole || "—"],
            ["Applied On",   new Date(app.createdAt).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" })],
          ].map(([k, v]) => (
            <div key={k}>
              <div style={{ fontSize: 10, color: "#94a3b8", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.07em" }}>{k}</div>
              <div style={{ fontSize: 14, color: "#0f172a", fontWeight: 600, marginTop: 3 }}>{v}</div>
            </div>
          ))}
          <div>
            <div style={{ fontSize: 10, color: "#94a3b8", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.07em" }}>Status</div>
            <div style={{ marginTop: 4 }}><Badge status={app.status} /></div>
          </div>
        </div>
      </div>

      {/* Cover letter */}
      <div style={{ marginBottom: 16 }}>
        <div style={{ fontSize: 13, fontWeight: 700, color: "#374151", marginBottom: 8 }}>Cover Letter</div>
        <div style={{
          background: "#f8fafc", borderRadius: 10, padding: 14,
          fontSize: 13, color: "#475569", maxHeight: 220, overflow: "auto",
          lineHeight: 1.65, whiteSpace: "pre-wrap", border: "1px solid #e2e8f0",
        }}>
          {app.coverLetter || "No cover letter provided."}
        </div>
      </div>

      {/* Resume */}
      {app.resumeUrl && (
        <a
          href={app.resumeUrl}
          target="_blank"
          rel="noreferrer"
          style={{
            display: "inline-flex", alignItems: "center", gap: 6,
            background: "#f1f5f9", color: "#374151", padding: "8px 14px",
            borderRadius: 8, fontSize: 13, fontWeight: 600,
            textDecoration: "none", marginBottom: 18,
          }}
        >
          📎 View / Download Resume
        </a>
      )}

      {/* Note */}
      <Textarea
        label="Agent Note (optional)"
        value={note}
        onChange={e => setNote(e.target.value)}
        placeholder="Add a note about this applicant…"
      />

      {/* Actions */}
      <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginTop: 4 }}>
        <Btn variant="secondary" size="sm" onClick={() => action("Shortlisted")} disabled={loading}>
          🔖 Shortlist
        </Btn>
        <Btn variant="success"   size="sm" onClick={() => action("Hired")}       disabled={loading}>
          ✓ Hire
        </Btn>
        <Btn variant="danger"    size="sm" onClick={() => action("Rejected")}    disabled={loading}>
          ✕ Reject
        </Btn>
        <Btn variant="outline"   size="sm" onClick={onClose}>
          Close
        </Btn>
      </div>
    </Modal>
  );
}